<template>
  <div style="padding-bottom: 52px">
    <div
      class="container-fluid small_screen_effect_container"
      style="position: relative; margin-bottom: 20px"
    >
      <WalletHeader />
      <div class="wc-container">
        <h4
          style="
            font-size: 20px;
            color: var(--mainGreenColor);
            margin-bottom: 22px;
          "
        >
          Convert coins
        </h4>

        <div class="wc-border bg-green-light">
          <div
            class="col-md-9 mx-auto"
            style="
              max-width: 420px !important;
              width: 100% !important;
              padding-bottom: 34px;
            "
          >
            <div>
              <!-- from coin -->
              <div class="text-center" style="width: 100%">
                <div class="select-button width-100 text-left">
                  <label for="">Convert from:</label>
                  <div
                    class="select-input select-input-input"
                    style="cursor: pointer !important"
                    role="button"
                    tabindex="0"
                    @click="modalState = 'from'"
                  >
                    <div style="pointer-events: none">
                      <img
                        style="cursor: pointer !important"
                        :src="fromCoin?.coin?.iconUrl"
                        alt=""
                      />
                      <input
                        type="text"
                        style="cursor: pointer !important; pointer-events: none"
                        disabled
                        :value="
                          fromCoin
                            ? `${fromCoin?.coin?.symbol} (${fromCoin?.amount})`
                            : undefined
                        "
                        placeholder="Select coin to convert from"
                      />
                    </div>
                    <i class="bx bx-chevron-down" id="selectToken"></i>
                  </div>
                </div>
              </div>
              <!-- to coin -->
              <div class="text-center" style="width: 100%">
                <div class="select-button width-100 text-left">
                  <label for="">Convert to:</label>
                  <div
                    class="select-input select-input-input"
                    style="cursor: pointer !important"
                    role="button"
                    tabindex="0"
                    @click="modalState = 'to'"
                  >
                    <div style="pointer-events: none">
                      <img
                        style="cursor: pointer !important"
                        :src="toCoin?.iconUrl || ''"
                        alt=""
                      />
                      <input
                        type="text"
                        style="cursor: pointer !important; pointer-events: none"
                        disabled
                        :value="toCoin?.symbol"
                        placeholder="Select coin to convert to"
                      />
                    </div>
                    <i class="bx bx-chevron-down" id="selectToken"></i>
                  </div>
                </div>
              </div>
              <!-- amount -->
              <div class="text-center" style="margin-bottom: 0px">
                <div class="select-button text-left width-100">
                  <label for=""
                    >Enter Amount
                    {{
                      fromCoin && toCoin
                        ? "(" +
                          fromCoin?.coin?.symbol +
                          " to " +
                          toCoin.symbol +
                          ")"
                        : ""
                    }}</label
                  >
                  <div class="select-input select-input-single">
                    <div>
                      <input
                        type="number"
                        v-model="amount"
                        placeholder="Enter amount here"
                      />
                    </div>
                    <!-- <i class="bx bx-chevron-down"></i> -->
                  </div>
                </div>
              </div>

              <!-- pricing -->
              <div
                v-if="pricing?.rate || loadingPricing"
                class="select-button-notes"
                style="margin-bottom: 0px; margin-top: 10px"
              >
                <div
                  class="select-button-notes-content"
                  style="
                    background-color: rgba(211, 211, 211, 0.4);
                    position: relative;
                    min-height: 50px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 4px;
                    justify-content: center;
                    padding: 10px 20px;
                  "
                >
                  <div class="wc-info">
                    <p class="display-block">Conversion Rate:</p>
                    <span
                      >{{
                        toCoin?.symbol &&
                        pricing?.rate &&
                        fromCoin?.coin?.symbol
                          ? `1 ${fromCoin.coin?.symbol} = ${pricing.rate} ${toCoin?.symbol}`
                          : "--"
                      }}
                    </span>
                  </div>
                  <div class="wc-info">
                    <p class="display-block">Transation fee:</p>
                    <span>
                      {{ pricing?.fee || "--" }}
                      {{ toCoin?.symbol }}
                    </span>
                  </div>

                  <div class="wc-info">
                    <p class="display-block">You will recieve:</p>
                    <span>
                      {{ pricing?.recieveAmount || "--" }}
                      {{ toCoin?.symbol }}
                    </span>
                  </div>

                  <div
                    v-if="loadingPricing"
                    class="d-flex justify-content-center align-items-center"
                    style="
                      position: absolute;
                      top: 0px;
                      left: 0px;
                      border-radius: 30px;
                      width: 100%;
                      height: 100%;
                      background-color: rgba(211, 211, 211, 0.4);
                      backdrop-filter: blur(3px);
                      z-index: 1000;
                    "
                  >
                    <LoadingComponent />
                  </div>
                </div>
              </div>

              <!-- submit button -->
              <div class="select-counter-button" style="margin-top: 30px">
                <button
                  class="relsify-button"
                  :disabled="!amount || !fromCoin || !toCoin || isSubmitting"
                  style="width: 100%; padding-block: 12px"
                  @click="handleConvertCoin"
                >
                  <span v-if="!isSubmitting">Convert coin</span>
                  <span class="loader" v-if="isSubmitting"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLE -->
    <div
      class="container-fluid small_screen_effect_container"
      style="position: relative"
    >
      <div class="wc-container">
        <h4
          style="
            font-size: 20px;
            color: var(--mainGreenColor);
            margin-bottom: 22px;
          "
        >
          Coin Conversion history
        </h4>

        <div class="relsify-table">
          <div class="table-responsive" style="padding: 0px !important">
            <table class="table">
              <thead class="text-left">
                <tr class="">
                  <th>From</th>
                  <th>To</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody
                class="text-left"
                v-if="!!allConversions && allConversions.length > 0"
              >
                <tr
                  v-for="(item, index) in allConversions"
                  :key="index"
                  @click="selectedConversion = item"
                >
                  <!-- from coin -->
                  <td>
                    <div class="td-with-image" style="cursor: pointer">
                      <img
                        style="border-radius: 100%"
                        :src="item.coinFrom.iconUrl"
                        alt=""
                      />
                      <span>
                        {{ $numberic(item.amount).format("0,0") }}
                        {{ item.coinFrom.symbol }}</span
                      >
                    </div>
                  </td>
                  <!-- to coin -->
                  <td>
                    <div class="td-with-image" style="cursor: pointer">
                      <img
                        style="border-radius: 100%"
                        :src="item.coinTo.iconUrl"
                        alt=""
                      />
                      <span>
                        {{
                          $numberic(item.recievedAmount).format(
                            "0,0.0[000000000000000]"
                          )
                        }}
                        {{ item.coinTo.symbol }}</span
                      >
                    </div>
                  </td>
                  <!-- date -->
                  <td>
                    <div>
                      <span style="margin-bottom: 0px">
                        {{
                          new Intl.DateTimeFormat("en-US", {
                            month: "short",
                            day: "2-digit",
                            year: "numeric",
                            hour: "numeric",
                            minute: "2-digit",
                            hour12: true,
                            timeZone: "UTC", // Force UTC time
                          }).format(new Date(item.updatedAt))
                        }}</span
                      >
                    </div>
                  </td>
                </tr>

                <!-- infinte scroll -->
                <tr>
                  <td colspan="6">
                    <div
                      class="text-center d-flex justify-content-center align-items-center"
                    >
                      <Infinitescrolltrigger />
                    </div>
                  </td>
                </tr>
              </tbody>
              <!-- empty -->
              <tbody
                class="text-left"
                v-if="
                  !loadingConversionHistory &&
                  !!allConversions &&
                  allConversions.length === 0
                "
              >
                <tr>
                  <td colspan="6">
                    <div class="text-center">
                      <h6>No Conversion History</h6>
                    </div>
                  </td>
                </tr>
              </tbody>
              <!-- loading -->
              <tbody class="text-left" v-if="loadingConversionHistory">
                <tr>
                  <td colspan="6">
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <br />
                      <LoadingComponent />
                      <br />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- SELECT COIN TO MODAL -->
    <Teleport to="body">
      <div class="select-modal" v-if="modalState === 'to'">
        <div
          class="select-modal-card vivify popInBottom"
          style="position: relative"
        >
          <!-- close btn -->
          <div class="close-select-button" @click="closeSelectedProjectModal">
            <i class="bx bx-x" id="closeToken"></i>
          </div>

          <div class="select-modal-search">
            <label for="">{{
              modalState === "from" ? "Convert from:" : "Convert to:"
            }}</label>
            <div class="relsify-search">
              <i class="bx bx-search-alt-2"></i>
              <input type="search" v-model="searchText" placeholder="Search" />
            </div>
          </div>

          <div class="select-modal-body">
            <div class="select-modal-content">
              <div style="width: 100%">
                <div
                  class="select-modal-item"
                  :class="toCoin?.symbol === item.symbol && 'selected'"
                  v-for="(item, index) in convertibleCoins"
                  :key="index"
                  @click="
                    () => {
                      toCoin = item;
                      modalState = 'idle';
                    }
                  "
                >
                  <p>
                    <img :src="item.iconUrl" alt="" />
                    <span>{{ item.symbol }}</span>
                    <small>{{ item.name }}</small>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="loadingConvertibleCoins"
            class="d-flex justify-content-center align-items-center"
            style="
              position: absolute;
              top: 0px;
              left: 0px;
              border-radius: 30px;
              width: 100%;
              height: 100%;
              background-color: rgba(211, 211, 211, 0.4);
              backdrop-filter: blur(3px);
              z-index: 1000;
            "
          >
            <LoadingComponent />
          </div>
        </div>
      </div>
    </Teleport>

    <!-- SELECT COIN FROM MODAL -->
    <Teleport to="body">
      <div class="select-modal" v-if="modalState === 'from'">
        <div
          class="select-modal-card vivify popInBottom"
          style="position: relative"
        >
          <!-- close btn -->
          <div class="close-select-button" @click="closeSelectedProjectModal">
            <i class="bx bx-x" id="closeToken"></i>
          </div>

          <div class="select-modal-search">
            <label for="">{{
              modalState === "from" ? "Convert from:" : "Convert to:"
            }}</label>
            <div class="relsify-search">
              <i class="bx bx-search-alt-2"></i>
              <input type="search" v-model="searchText" placeholder="Search" />
            </div>
          </div>

          <div class="select-modal-body">
            <div class="select-modal-content">
              <div style="width: 100%">
                <div
                  class="select-modal-item"
                  :class="
                    fromCoin?.coin?.symbol === item.coin?.symbol && 'selected'
                  "
                  v-for="(item, index) in balances"
                  :key="index"
                  @click="
                    () => {
                      fromCoin = item;
                      modalState = 'idle';
                    }
                  "
                >
                  <p style="display: flex; justify-content: space-between">
                    <span>
                      <img :src="item.coin?.iconUrl" alt="" />
                      <span>{{ item.coin?.symbol }}</span>
                      <small>{{ item.coin?.name }}</small></span
                    >

                    <small>({{ item.amount }} {{ item.coin.symbol }})</small>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="balances == null"
            class="d-flex justify-content-center align-items-center"
            style="
              position: absolute;
              top: 0px;
              left: 0px;
              border-radius: 30px;
              width: 100%;
              height: 100%;
              background-color: rgba(211, 211, 211, 0.4);
              backdrop-filter: blur(3px);
              z-index: 1000;
            "
          >
            <LoadingComponent />
          </div>
        </div>
      </div>
    </Teleport>

    <!-- Selected Conversion modal -->
    <Teleport to="body">
      <div class="select-modal" v-if="!!selectedConversion">
        <div
          class="select-modal-card vivify popInBottom"
          style="position: relative"
        >
          <!-- close btn -->
          <div class="close-select-button" @click="selectedConversion = null">
            <i class="bx bx-x" id="closeToken"></i>
          </div>

          <div class="select-modal-body">
            <div class="select-modal-content">
              <div
                style="
                  width: 100%;
                  padding: 20px 10px;
                  display: flex;
                  flex-direction: column;
                  gap: 10px;
                  align-items: stretch;
                "
              >
                <div class="wc-info">
                  <p>Converted from:</p>
                  <span
                    >{{ selectedConversion.coinFrom.name }} (
                    {{ selectedConversion.coinFrom.symbol }})</span
                  >
                </div>
                <div class="wc-info">
                  <p>Converted to:</p>
                  <span
                    >{{ selectedConversion.coinTo.name }} ({{
                      selectedConversion.coinTo.symbol
                    }})</span
                  >
                </div>
                <div class="wc-info">
                  <p>Swapped amount:</p>
                  <span
                    >{{ selectedConversion.amount }}
                    {{ selectedConversion.coinFrom.symbol }}</span
                  >
                </div>
                <div class="wc-info">
                  <p>Fee:</p>
                  <span>{{ selectedConversion.fee }}</span>
                </div>
                <div class="wc-info">
                  <p>Rate:</p>
                  <span>{{ selectedConversion.price }}</span>
                </div>
                <div class="wc-info">
                  <p>Recieved:</p>
                  <span>{{ selectedConversion.recievedAmount }}</span>
                </div>
                <div class="wc-info">
                  <p>Date:</p>
                  <span>{{
                    new Intl.DateTimeFormat("en-US", {
                      month: "short",
                      day: "2-digit",
                      year: "numeric",
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                      timeZone: "UTC", // Force UTC time
                    }).format(new Date(selectedConversion.updatedAt))
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import "@/assets/css/dashboard.css";
import "@/mixins";
import { mapActions, mapGetters } from "vuex";
import LoadingComponent from "../../components/loading/LoadingComponent.vue";
import WalletHeader from "./WalletHeader.vue";

// coins type
// createdAt: string
// deletedAt?: string
// external: boolesn
// iconUrl: string
// id: string
// name: string
// status: string
// symbol: string
// symbolText: string
// type: "crypto" | "fiat"
// updatedAt string

export default {
  components: {
    WalletHeader,
    LoadingComponent,
  },

  methods: {
    ...mapActions(["setCurrentPageName", "setAlertpopUp", "globalFunction"]),
    closeSelectedProjectModal: function () {
      this.modalState = "idle";
      this.searchText = "";
    },
    async getConvertibleCoins() {
      this.loadingConvertibleCoins = true;
      let url = `${this.RELSIFY_URL}/api/trade/convert/coins`;

      this.axios
        .get(url)
        .then((response) => {
          this.globalFunction();
          if (!response.data.error) {
            this.convertibleCoinsArray = response.data.data;
            // console.log("ppppp", this.convertibleCoinsArray, response);
          } else {
            this.setAlertpopUp({
              status: true,
              title: "Error",
              des: response.data.meta.message,
              type: "error",
              payload: null,
            });
          }
          this.loadingConvertibleCoins = false;
        })
        .catch(() => {
          this.loadingConvertibleCoins = false;
          this.setAlertpopUp({
            status: true,
            title: "Error",
            des: "An Error occured",
            type: "error",
            payload: null,
          });
        });
    },

    async getConvertionHistory() {
      this.loadingConversionHistory = true;
      let url = `${this.RELSIFY_URL}/api/trade/convert/history`;

      this.axios
        .get(url)
        .then((response) => {
          this.globalFunction();
          if (!response.data.error) {
            this.allConversions = response.data.data;
            // console.log("ppppp", this.allConversions, response);
          } else {
            this.setAlertpopUp({
              status: true,
              title: "Error",
              des: response.data.meta.message,
              type: "error",
              payload: null,
            });
          }
          this.loadingConversionHistory = false;
        })
        .catch(() => {
          this.loadingConversionHistory = false;
          this.setAlertpopUp({
            status: true,
            title: "Error",
            des: "An Error occured",
            type: "error",
            payload: null,
          });
        });
    },

    async getConversionRate() {
      this.loadingConversionRate = true;
      let url = `${this.RELSIFY_URL}/api/trade/convert/rate`;

      this.axios
        .post(url, {
          fromCoin: this.fromCoin?.coin?.symbol,
          toCoin: this.toCoin?.symbol,
        })
        .then((response) => {
          if (!response.data.error) {
            this.rate = response.data.data?.rate || "0";
            // console.log("ppppp", response);
          } else {
            this.setAlertpopUp({
              status: true,
              title: "Error",
              des: response.data.meta.message,
              type: "error",
              payload: null,
            });
          }
          this.loadingConversionRate = false;
        })
        .catch(() => {
          this.setAlertpopUp({
            status: true,
            title: "Error",
            des: "An Error occured",
            type: "error",
            payload: null,
          });
        });
      this.loadingConversionRate = false;
    },

    async getPricing() {
      this.loadingPricing = true;
      let url = `${this.RELSIFY_URL}/api/trade/convert/pricing`;

      this.axios
        .post(url, {
          fromCoin: this.fromCoin?.coin?.symbol,
          toCoin: this.toCoin?.symbol,
          amount: this.amount,
        })
        .then((response) => {
          if (!response.data.error) {
            this.pricing = response.data.data;
            // console.log("ppppp", response);
          } else {
            this.setAlertpopUp({
              status: true,
              title: "Error",
              des: response.data.meta.message,
              type: "error",
              payload: null,
            });
          }
          this.loadingPricing = false;
        })
        .catch(() => {
          this.loadingPricing = false;
          this.setAlertpopUp({
            status: true,
            title: "Error",
            des: "An Error occured",
            type: "error",
            payload: null,
          });
        });
    },

    async handleConvertCoin() {
      this.isSubmitting = true;
      let url = `${this.RELSIFY_URL}/api/trade/convert`;

      this.axios
        .post(url, {
          fromCoin: this.fromCoin?.coin?.symbol,
          toCoin: this.toCoin?.symbol,
          amount: this.amount,
        })
        .then((response) => {
          if (!response.data.error) {
            this.getConvertionHistory();
            this.pricing = {};
            this.amount = 0;
            this.fromCoin = null;
            this.toCoin = null;

            this.setAlertpopUp({
              status: true,
              title: "Success",
              des: response.data.meta.message,
              type: "success",
              payload: null,
            });
            // console.log("ppppp", response);
          } else {
            this.setAlertpopUp({
              status: true,
              title: "Error",
              des: response.data.meta.message,
              type: "error",
              payload: null,
            });
          }
          this.isSubmitting = false;
        })
        .catch((err) => {
          this.isSubmitting = false;
          // console.log("errrrrrr", err.response);
          this.setAlertpopUp({
            status: true,
            title: "Error",
            des: err?.response?.data?.meta?.message || "An Error occured",
            type: "error",
            payload: null,
          });
        });
    },
  },

  data() {
    return {
      modalState: "idle", // "idle" | "from" | "to"
      searchText: "",
      amount: 0,
      loading: false,
      loadingConvertibleCoins: false,
      loadingConversionHistory: false,
      loadingConversionRate: false,
      loadingPricing: false,
      isSubmitting: false,
      convertibleCoinsArray: [],
      allConversions: [],
      fromCoin: null,
      toCoin: null,
      rate: "0",
      pricing: null,
      selectedConversion: null,
    };
  },
  watch: {
    fromCoin(newValue) {
      if (newValue && this.toCoin && this.amount) {
        this.loadingPricing = true;
        this.getPricing();
      }
    },
    toCoin(newValue) {
      if (newValue && this.fromCoin && this.amount) {
        this.loadingPricing = true;
        this.getPricing();
      }
    },
    amount(newValue) {
      if (newValue && this.toCoin && this.fromCoin) {
        this.loadingPricing = true;
        this.getPricing();
      }
    },
  },

  computed: {
    ...mapGetters(["userWalletBalance", "currentCurrencyType"]),

    balances() {
      let balances = null;

      if (this.userWalletBalance && this.userWalletBalance.length > 0) {
        balances = this.userWalletBalance.filter(
          (balance) =>
            String(balance.coin.external).match("true") &&
            (balance.coin.name
              .toLowerCase()
              .includes(this.searchText.toLowerCase()) ||
              balance.coin.symbol
                .toLowerCase()
                .includes(this.searchText.toLowerCase()))
        );

        if (balances) {
          balances = balances.sort(
            (a, b) => parseFloat(b.usdValue) - parseFloat(a.usdValue)
          );
        }
      }

      //   console.log("balances", balances);
      return balances;
    },
    convertibleCoins() {
      let convertibleCoins = [];

      if (this.convertibleCoinsArray && this.convertibleCoinsArray.length > 0) {
        convertibleCoins = this.convertibleCoinsArray.filter(
          (coin) =>
            coin.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
            coin.symbol.toLowerCase().includes(this.searchText.toLowerCase())
        );
      }

      return convertibleCoins || [];
    },
  },

  mounted() {
    this.getConvertibleCoins();
    this.getConvertionHistory();
    this.setCurrentPageName(this.$router.currentRoute._rawValue.name);
  },

  beforeRouteLeave(to, from, next) {
    next();
  },
};
</script>

<style scoped>
@media screen and (max-width: 580px) {
  .select-modal-card {
    width: 100%;
    height: 100%;
    padding: 17px 19px;
    border-radius: 0px;
  }

  .select-modal .select-modal-search label {
    font-size: 15px;
  }

  .select-modal-item p img {
    width: 35px;
  }

  .select-modal-item p span {
    font-size: 19px;
  }

  .select-modal-item p small {
    font-size: 11px;
  }
}

.wc-container {
  background-color: white;
  padding-block: 34px;
  padding-inline: 20px;
}
.wc-border {
  /* border: 1px solid #eee; */
  padding-block: 10px;
  padding-inline: 10px;
  border-radius: 10px;
}
.wc-flex {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
}

.wc-info {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center !important;

  width: 100%;
}
div.wc-info p {
  flex: 1;
  text-align: start;
  margin-bottom: 0px;
  font-size: 14px;
  max-width: 140px;
  min-width: 140px;
  font-weight: 600;
}
div.wc-info span {
  display: inline-block;
  word-break: break-all;
  flex: 1;
  text-align: end;
  font-size: 14px;
  font-weight: bold;
}

@media screen and (max-width: 580px) {
  .wc-flex {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
